//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  props: {
    articles: {
      type: Number,
      default: null,
    },
    downloads: {
      type: Number,
      default: null,
    },
    searchTerm: {
      type: String,
      default: null,
    },
    itemsBreadcrumb: {
      type: Array,
      default() {
        return [
          { title: this.$translation('resultsFound.title'), slug: "/search" }
        ];
      },
    },
  },
  computed: {
    breadcrumb() {
      const breadcrumbSimple = !this.itemsBreadcrumb? [{ title: this.title, slug: ''}] : null
      return breadcrumbSimple;
    },
  },
  data() {
    return {
      currentIndex: this.dataIndex,
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 164,
          height: 139,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-learn-04.svg?data`),
          width: 119,
          height: 141,
          alt: '',
        },
      ],
    }
  },
}
